<div class="footer-div" wmAnimate="jackInTheBox" speed="normal">
  <p class="footer-text">	&copy; 2023, Built with ❤️ by Sreekanth Mandala</p>
</div>
